import React, { useEffect } from 'react';
import { Panel } from 'rsuite';
import PageHeader from './pageHeader';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

export default function Page({ pageName, children, expand, setExpand }) {
  const cookies = new Cookies();
  const navigator = useNavigate();

  const refreshToken = () => {
    fetch(`${process.env.API_HOST}/api/token/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + cookies.get('token'),
      },
    }).then((res) => {
      res.json().then((data) => {
        console.log(data);

        if (data.access_token) {
          cookies.set('token', data.access_token, { path: '/', maxAge: 3600 });
        } else {
          navigator('/login');
          cookies.remove('token', { path: '/' });
        }
      });
    });
  };

  useEffect(() => {
    //refreshToken();
    setInterval(refreshToken, 1000 * 3000);
  }, []);

  return (
    <Panel className="page-panel" header={<PageHeader expand={expand} setExpand={setExpand} pageName={pageName} />}>
      {children}
    </Panel>
  );
}